module.exports = __webpack_public_path__ + "ddb83ddccd6bed2815c59d0ae4a10c5c.MP3";